import React from 'react';

export interface SearchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange?: (value: string) => void;
  onSearch?: (value: string) => void;
}

export const Search = React.forwardRef<HTMLInputElement, SearchProps>(
  ({ className = '', onSearch, onChange, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.value);
      onSearch?.(e.target.value);
    };

    return (
      <div className={`relative ${className}`}>
        <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
        <input
          ref={ref}
          type="text"
          onChange={handleChange}
          className="w-full pl-10 pr-4 py-2 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-500/20 focus:border-brand-500 transition-all placeholder:text-gray-400"
          {...props}
        />
      </div>
    );
  }
);

Search.displayName = 'Search';
